import { Configuration } from "@virtualprogaming/js-public-sdk";
import axios, { AxiosInstance } from "axios";
import { useMemo } from "react";

import { environment } from "~/environment";

import { useAuth, useAuthApi, useCurrentUser } from "./auth";

function useAxios(): AxiosInstance {
  const { access, refresh, setTokens } = useAuth();
  const currentUser = useCurrentUser();
  const api = useAuthApi();
  const authExp = useMemo(() => (currentUser?.exp ?? 0) * 1000, [currentUser]);
  return useMemo(() => {
    const ax = axios.create();
    ax.interceptors.request.use((config) => {
      if (access) {
        if (Date.now() > authExp) {
          if (refresh) {
            return api.refreshToken({ access, refresh }).then((res) => {
              const { data } = res;
              setTokens(data);
              config.headers.Authorization = `Bearer ${data.access}`;
              return config;
            });
          }
        } else {
          config.headers.Authorization = `Bearer ${access}`;
          return config;
        }
      }
      return config;
    });
    return ax;
  }, [access, api, authExp, refresh, setTokens]);
}

export type ApiConfig = [Configuration?, string?, AxiosInstance?];

export function useApiConfig(): ApiConfig {
  const ax = useAxios();
  return [undefined, `${environment.API_PREFIX}/public`, ax];
}
